import React, { useState } from 'react';
import Switch from 'react-switch';
import Tick from '../../../assets/tick.png';
import UnTick from '../../../assets/untick.png';
import { Product } from '../../../types/ProductTypes';

interface EachProductStatusProps {
    eachItem: Product;
    pageProps: {
        pageNumber: number;
        pageSize: number;
        toggleProductRequest: {
            is_request_processing: boolean;
        };
    };
    isSelected: boolean;
    handleActiveChange: (itemId: string, isActive: boolean) => void;
}

export const EachProductStatus = ({ eachItem, pageProps, isSelected, handleActiveChange }: EachProductStatusProps) => {
    const [productStatus, setProductStatus] = useState<boolean>(eachItem.isActive);

    const handleToggle = (checked: boolean) => {
        setProductStatus(checked);
        handleActiveChange(eachItem.id, checked);

        // Optional: If you want to update immediately on toggle
        let togglePayload = {
            storeId: eachItem?.storeId,
            productId: eachItem?.id
        };

        let payload = `Page=${pageProps.pageNumber}&Size=${pageProps.pageSize}`;
    };

    return (
        <Switch
            checkedIcon={true}
            checkedHandleIcon={< img className="tick_img" src={Tick} />}
            uncheckedHandleIcon={< img className="un_tick_img" src={UnTick} />}
            uncheckedIcon={true}
            width={40}
            height={20}
            disabled={pageProps.toggleProductRequest.is_request_processing || !isSelected}
            onHandleColor="#FFFFFF"
            onColor="#00A85B"
            offHandleColor="#9B9B9B"
            offColor="#D8D8D8"
            onChange={handleToggle}
            checked={productStatus}
        />
    );
};

